export default __webpack_public_path__ + "static/media/030_corner1.last.c5fd3109.png";